document.addEventListener('DOMContentLoaded', () => {
    const progressBarAfter = document.querySelector('.progress-bar-after');
    // End if no progressbar on screen
    if (!progressBarAfter) return


    const progressBarStart = document.querySelector('.reading-progress-start');
    const stickyContent = document.querySelector('.sticky-content-top');
    const stickySocialMedia = document.querySelector('.sticky-social-media');

    if (window.scrollY > 150) {
        progressBarStart.style.display = 'none';
        stickyContent.classList.add('visible');
        stickySocialMedia.classList.add('visible');
    }

    const handleScroll = () => {
        const scrollY = window.scrollY;

        if (scrollY >= 100) {
            progressBarStart.style.display = 'none';

            stickyContent.classList.add('visible');
            const totalHeight = document.body.scrollHeight - window.innerHeight;
            const scrollPercentage = (scrollY / totalHeight) * 100;
            progressBarAfter.style.width = `${scrollPercentage}%`;

            const remainingHeight = totalHeight - scrollY;

            if (remainingHeight <= 1010) {
                stickySocialMedia.classList.remove('visible'); // Cache la div
            } else {
                stickySocialMedia.classList.add('visible'); // Affiche la div
            }

        } else {
            progressBarStart.style.display = 'block'

            stickyContent.classList.remove('visible');

            stickySocialMedia.classList.remove('visible');

        }
    };

    window.addEventListener('scroll', handleScroll);
});
